<template>
    <div class="min-h-screen bg-[#0E171F] text-white py-2 md:py-6"
        style="background-image: url('/images/backgrounds/page_ticket.png');  background-position: center; background-repeat: no-repeat;">
        <div class="w-11/12 mx-auto \ space-y-3">

            <div class=" text-center  rounded-lg relative">
                <h2 class="text-3xl font-alize font-semibold underline text-yellow-300 tracking-widest uppercase">
                    {{ $t('ticketinformation') }}
                </h2>
                <p class="text-lg font-bold text-yellow-200 mt-2">
                    <span class="text-yellow-400">
                        {{ $t('billetsetboissonsuniquemenent') }}
                    </span>
                </p>
                <p class="text-md text-slate-200 mt-2">
                    {{ $t('vouspouvezcompletervosbillets') }}
                </p>
                <p class="text-lg font-semibold  mt-2 underline text-yellow-500 ">
                    {{ $t('serviceatableinclus') }}
                </p>

                <p
                    class="mt-4 text-center text-[#950C16] text-base font-medium bg-[#FFEBEB] px-4 py-2 rounded-xl shadow-sm max-w-md mx-auto">
                    {{ $t('billetsnonrembousables') }}
                </p>
            </div>

            <!-- Loader -->
            <div v-if="loading" class="flex flex-col items-center space-y-4">
                <div class="animate-spin ease-linear rounded-full w-10 h-10 border-t-2 border-b-2 border-white"></div>
                <p class="text-gray-400">{{ $t('chargementdestickets') }}</p>
            </div>



            <!-- Liste des tickets -->
            <div v-else class="w-full flex justify-center my-6">
                <div v-if="tickets.length > 0" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
                    <div v-for="ticket in tickets" :key="ticket.id" :class="[
                        'relative group p-6 rounded-xl shadow-xl transition-transform duration-500',
                        ticket.stock.remaining === 0
                            ? 'bg-gray-500  cursor-not-allowed'
                            : getTicketClass(ticket.type) + ' transform hover:scale-105 cursor-pointer'
                    ]">
                        <!-- Animation floue sur hover -->
                        <div
                            class="absolute -inset-0.5 bg-gradient-to-r from-[#e6204b] to-[#FF8C42] rounded-xl blur opacity-0  transition duration-500">
                        </div>

                        <div class="relative z-10 flex flex-col justify-between h-full">
                            <div class="grid w-full grid-cols-2">
                                <div>
                                    <h2 class="text-xl font-semibold text-white mb-2">{{ ticket.type }}</h2>
                                    <p class="text-3xl font-extrabold my-4">{{ ticket.price }} €</p>
                                    <p :class="{
                                        'text-green-400': ticket.stock.remaining > 20,
                                        'text-yellow-400': ticket.stock.remaining <= 20 && ticket.stock.remaining > 5,
                                        'text-red-400': ticket.stock.remaining <= 5,
                                        'text-gray-300': ticket.stock.remaining === 0,
                                    }" class="font-medium mb-4">
                                        {{ ticket.stock.remaining > 0 ? $t('disponible') : $t('epuise') }}
                                    </p>
                                </div>

                                <div class="w-full flex justify-center items-center">
                                    <img :src="`/images/tickets/${ticket.type}.png`" class="h-36"
                                        :class="ticket.stock.remaining === 0 ? 'opacity-60 grayscale' : ''" alt="" />
                                </div>
                            </div>

                            <div>
                                <ul class="list-disc list-inside space-y-px">
                                    <li v-for="(line, index) in getOffres(ticket)" :key="index"
                                        class="flex items-center space-x-1 font-medium">
                                        <span>{{ line.text }}</span>
                                        <sup v-if="line.note" class="text-sm font-semibold text-[#FF8C42] ml-1">
                                            ({{ line.note }})
                                        </sup>
                                    </li>
                                </ul>

                            </div>

                            <div v-if="ticket.stock.remaining > 0" class="mt-4 w-full">
                                <router-link :to="`/Tables?ticket=${ticket.type}`"
                                    class="inline-block bg-gradient-to-r text-sm md:text-md text-center w-full from-[#e6204b] to-[#FF8C42] text-white font-semibold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300">
                                    {{ $t('achetermaintenant') }}
                                </router-link>
                            </div>
                        </div>


                    </div>
                </div>
                <!-- Aucun ticket -->
                <div v-else class="text-center text-gray-400 mt-20">
                    <p>{{ $t('aucuneticketdisponiblepourcetevenement') }}.</p>
                </div>
            </div>
            <div class="text-center mt-5" v-if="tickets.length > 0">
                <router-link to="/Tables"
                    class="inline-block bg-white text-neutral-900 text-base md:text-lg font-semibold tracking-tight px-8 py-3 rounded-full shadow-sm ring-1 ring-neutral-300 hover:bg-neutral-100 hover:ring-neutral-400 transition-all duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-400">
                    {{ $t('voirlasalle') }}
                </router-link>
            </div>

            <div class="w-full mb-6">
                <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 shadow-sm text-center">

                    <p class="text-xs text-gray-500 ">
                        (1) {{ $t('textedefin') }}
                    </p>
                </div>
            </div>


        </div>
    </div>

</template>

<script>
export default {
    computed: {
        currentLocale() {
            return this.$i18n.locale
        }
    },
    created() {
        this.loading = true;
        this.axios.get(this.$store.state.api + "/ShowTicket", {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(({ data }) => {
                this.loading = false;
                this.eventTitle = data[0].titre;
                this.tickets = data[1];
            })
            .catch(error => {
                this.loading = false;
                this.error = "Impossible de charger les tickets.";
                console.error("Erreur détaillée :", error.response || error);
            });
    },
    data() {
        return {
            eventTitle: "",
            tickets: [],
            loading: false,
            error: null, // Nouveau champ d'erreur
        };
    },
    methods: {
        getTicketClass(type) {
            const colors = {
                VIP: "bg-gradient-to-br from-[#FFD700] via-[#FFA500] to-[#FF8C00]",
                Regular: "bg-gradient-to-br from-[#4CAF50] via-[#2E7D32] to-[#1B5E20]",
                "Early Bird": "bg-gradient-to-br from-[#2196F3] via-[#1976D2] to-[#0D47A1]",
                "Last Minute": "bg-gradient-to-br from-[#FF5722] via-[#E64A19] to-[#BF360C]",
            };
            return colors[type] || "bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900";
        },

        selectTicket(ticket) {
            localStorage.setItem("TICKETSELECTED", JSON.stringify(ticket))
            this.$store.state.ticketSelected = ticket
            this.$router.push('/tables')
        },

        getOffres(ticket) {
            let offres = ticket.offres

            // Si c’est encore une string JSON ➜ parse
            if (typeof offres === 'string') {
                try {
                    offres = JSON.parse(offres)
                } catch (e) {
                    console.error('Erreur JSON:', e)
                    return []
                }
            }

            console.log('offres:', offres)
            return offres[this.currentLocale] || offres['fr'] || []
        }
    },

};
</script>
